import { useRef } from "react";
import { useAppTranslation } from "../../i18n/useAppTranslation";
import { useFormStatesQuery } from "../../api/formStates/useFormStatesQuery";
import { authService } from "../../services/AuthService";
import { pickFormStateRecord } from "../../store/formStates/utilities";
import { LOCATION_STATE_KEY } from "../../store/formStates/config";
import { history } from "../../history";
import { uiNotification } from "../../services/UINotificationService";
import { useDeleteFormStateMutation } from "../../api/formStates/useDeleteFormStateMutation";

export const useRestoreLocation = () => {
  const restored = useRef(false);
  const del = useDeleteFormStateMutation();

  const { tCommon: t } = useAppTranslation.Common({
    keyPrefix: "restoreFormState",
  });

  useFormStatesQuery({
    onSuccess: (data) => {
      if (authService.isLoggedIn() && !restored.current) {
        const savedRecord = pickFormStateRecord(data);
        if (!savedRecord) return;
        restored.current = true;
        del
          .mutateAsync({ id: savedRecord.id })
          .then(() => {})
          .catch(() => {})
          .finally(() => {
            uiNotification.info(t("notification"));
            history.push(savedRecord.path.replace(window.location.origin, ""), {
              [LOCATION_STATE_KEY]: savedRecord,
            });
          });
      }
    },
  });
};
